import axiosInstance from "../axiosInstance";
import apiClient from "./axiosInstancePlant";

// export const fetchUsers = () => {
//   return axiosInstance.get('/users');
// };

export const createPlantOwner = async (plantData) => {
  return await apiClient.post("/processingplant", plantData);
};

// Export a constant function called getPlants which is an asynchronous function that returns the result of the apiClient.get() method, which is called with the argument "/api/processing-plants"
// Export a constant function called getPlants that returns a promise
export const getPlants = async () => {
  // Use the apiClient to make a GET request to the /api/processing-plants endpoint
  return await apiClient.get("/api/processing-plants");
};

export const getPlantById = async (id) => {
  return await apiClient.get(`/processingplant/${id}`);
};

export const getPlantByUserId = async (userId) => {
  return await apiClient.get(`/processingplant1/${userId}`);
};

export const getProccesingCostByPlantId = async (id) => {
  if (!id) {
    throw new Error("Stock ID is required");
  }
  return await apiClient.get(`/getProcessingCost/${id}`);
};

export const deleteProcessingCost = async (id) => {
  return await apiClient.delete(`/processingCostDelete/${id}`);
};

export const addProccesingCost = async (costData) => {
  return await apiClient.post("/processingCost", costData);
};

export const getProcessingCostsByIdandType = async (plantId, type) => {
  if (!plantId) {
    throw new Error("plant ID is required");
  }
  return await apiClient.get(
    `/getProcessingCostsByIdandType?plantId=${plantId}&fishType=${type}`
  );
};

export const getTruckDriver = async (userId) => {
  return await apiClient.get(`/truckDriver/${userId}`);
};

export const getIdGivenUserId = async (userId) => {
  return await apiClient.get(`/processingplantId/${userId}`);
};
